import { render } from "./CoHostView.vue?vue&type=template&id=6e018f65"
import script from "./CoHostView.vue?vue&type=script&lang=js"
export * from "./CoHostView.vue?vue&type=script&lang=js"

import "./CoHostView.vue?vue&type=style&index=0&id=6e018f65&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__